<script>
	export default {
		modelData: ['submittedSchoolRemotenessBanner'],
		computed: {
			justSubmittedRemoteness() {
				return Date.now() - (this.submittedSchoolRemotenessBanner || 0) < 10000;
			}
		}
	};
</script>
<template>
	<div class="please-review-school-campaign-component text-centered">
		<template v-if="justSubmittedRemoteness"> Thank you! </template>
		<a href="/my-account#!myAccountTab:teaching/">Please review</a>
		your grade and school to make sure it's up to date.
	</div>
</template>
